export const rucStatus = [
    {
      name: 'Si',
      value: 'true',
    },
    {
      name: 'No',
      value: 'false',
    }
  ];